import { Injectable } from '@angular/core';
import { ILoginResponseDto, IUserSettingsDto } from '@nft-folks/interfaces';
import { StoreConfig, Store } from '@datorama/akita';

export type AuthState = ILoginResponseDto & {
  connectedWallet?: {
    chainId: string;
    address: string;
  };
};
export function createInitialState(): AuthState {
  return {} as AuthState;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'auth', resettable: true })
export class AuthStore extends Store<AuthState> {
  constructor() {
    super(createInitialState());
  }

  updateSettings(settings: IUserSettingsDto) {
    this.update((state: AuthState) => {
      return {
        ...state,
        profile: {
          ...state.profile,
          settings: settings as any,
        },
      } as AuthState;
    });
  }

  setConnectedWalletAddress(address: string) {
    this.update((state) => {
      return { ...state, connectedWallet: { ...state.connectedWallet, address } } as AuthState;
    });
  }

  setConnectedChainId(chainId: string) {
    this.update((state) => {
      return {
        ...state,
        connectedWallet: { ...state.connectedWallet, chainId: chainId },
      } as AuthState;
    });
  }
}
